import ErrorBase from '@components/ErrorBase'

export default function NotAuthorized({ error, resetErrorBoundary }) {
  return <ErrorBase title="Sorry" subtitle="You are not allowed to view this page!" code={401} error={error} reset={resetErrorBoundary} />
}
